import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONOS = [{
  num: '01',
  title: 'Meditaciones para Conectar con tu Energía Femenina',
  desc: '7 meditaciones guiadas listas para leer o grabar. Para la ansiedad aguda, el insomnio, la desconexión emocional y los días más difíciles. Con tabla de uso rápido: ¿Qué meditación necesito hoy? Con rutina semanal sugerida y registro de práctica incluido.',
  value: '$8.500'
}, {
  num: '02',
  title: 'Recetario Holístico Anti Estrés',
  desc: '15 recetas simples, cálidas y reconfortantes para el sistema nervioso femenino. Lista de compras semanal y planner de 7 días incluidos. Incluye la Leche Dorada Nocturna y la Infusión Femenina de la Academia.',
  value: '$9.000'
}, {
  num: '03',
  title: 'Guía Práctica de Aromaterapia Femenina',
  desc: '10 fórmulas aromáticas listas para usar. Roll on anti-ansiedad, aceite de conexión femenina sagrada, difusor de sueño profundo y más. Con tabla de uso rápido: ¿Qué aroma necesito hoy?',
  value: '$9.500'
}, {
  num: '04',
  title: 'Diario Emocional Femenino Imprimible',
  desc: 'Tu espacio sagrado de escritura. Con check in de mañana y noche, escala emocional, páginas de descarga, gratitud profunda, afirmaciones y revisión semanal. Listo para imprimir y usar hoy mismo.',
  value: '$8.000'
}, {
  num: '05',
  title: 'Ritual de Luna y Energía Creativa',
  desc: 'Los 4 rituales lunares completos con hojas imprimibles de intenciones y liberación. Tu sistema mensual de sincronización femenina. Con Calendario Lunar Femenino Perpetuo incluido.',
  value: '$9.000'
}, {
  num: '06',
  title: 'Afirmaciones de Abundancia y Bienestar Femenino',
  desc: '120 afirmaciones organizadas en 6 bloques: calma, amor propio, energía femenina, confianza, merecimiento y descanso. Con tarjetas imprimibles, plan de 7 días y protocolo de mañana y noche.',
  value: '$8.000'
}];
export function BenefitsSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-brand-primary py-8 md:py-10 px-5 sm:px-6 border-t border-brand-border-soft" data-id="element-19">
      <div className="container mx-auto max-w-4xl" data-id="element-20">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-21">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-brand-heading uppercase tracking-widest" data-id="element-22">
            🎁 6 BONOS INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-23">
          {BONOS.map((bono, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal relative bg-brand-card border border-brand-border-soft rounded-[16px] p-6 pt-8 transition-all hover:shadow-medium shadow-soft ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 50}ms`
          }} data-id="element-24">
                <div className="absolute -top-3 left-6 bg-brand-cta text-white font-bold text-xs px-3 py-1 rounded-md uppercase tracking-wider" data-id="element-25">
                  🎁 BONO {bono.num}
                </div>

                <h3 className="text-brand-heading font-serif font-bold text-xl mb-3 leading-tight" data-id="element-26">
                  {bono.title}
                </h3>
                <p className="text-brand-body text-sm leading-relaxed mb-4 flex-grow" data-id="element-27">
                  {bono.desc}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-brand-border-soft mt-auto" data-id="element-28">
                  <span className="text-brand-soft line-through text-sm" data-id="element-29">
                    {bono.value}
                  </span>
                  <span className="bg-[#FCE4EC] text-[#880E4F] font-bold text-xs px-2 py-1 rounded-[6px] tracking-wider" data-id="element-30">
                    GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div ref={ref2} className={`reveal text-center bg-white/50 rounded-xl border border-brand-border-soft py-4 shadow-sm ${vis2 ? 'is-visible' : ''}`} data-id="element-31">
          <p className="text-xl md:text-2xl font-serif font-bold text-brand-heading" data-id="element-32">
            Valor total de bonos:{' '}
            <span className="text-brand-soft line-through" data-id="element-33">$52.000</span>{' '}
            <span className="text-brand-cta" data-id="element-34">→ GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}